import React from "react";
import CommonDatePicker from "@/common/elements/DatePicker";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TimePicker from "@/common/elements/TimePicker";
import {
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
} from "@/common/styles";
import { getOptionsFromRefList } from "@/util/common_function";
import { useSelector } from "react-redux";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import SecureFormItem from "@/common/SecureFormItem";
import { SCHEMA_NAME } from "@/util/common_variable";

const JailIncidentInmateAdmitsGuilt = ({ isFieldEnable, startingPoint = "" }) => {
  return (
    <>
      <StyledSectionHeading marginTop="20px">
        <span>Inmate Admits Guilt and Accepts Consequences</span>
      </StyledSectionHeading>

      <FieldSecurityProvider
        entity={SCHEMA_NAME.JAIL_INCIDENTS_INVOLVED_INMATE}
        startingPoint={startingPoint}
        bookingsFieldsEnabled={isFieldEnable}
      >
        <StyledGridRow gutter={16}>
          <StyledGridCol>
            <SecureFormItem
              fieldName="accept"
              formItemProps={{ 
                label: "Accept?",
                layout: "horizontal",
                labelPostion: "label-right",
                paddingTop: "24px",
                name: "accept",
                valuePropName: "checked",
              }}
            >
              <Checkbox disabled={!isFieldEnable} />
            </SecureFormItem>
          </StyledGridCol>

          <StyledGridCol lg={7}>
            <SecureFormItem
              fieldName="acceptByStaffID"
              formItemProps={{ 
                label: "Accept Officer",
                name: "acceptByStaffID",
              }}
            >
              <Select
                options={getOptionsFromRefList("", true, false, true)}
                disabled={!isFieldEnable}
              />
            </SecureFormItem>
          </StyledGridCol>

          <StyledGridCol lg={5}>
            <SecureFormItem
              fieldName="acceptByStaffID"
              formItemProps={{ 
                label: "Accept Date / Time",
                name: "acceptDateTime",
              }}
            >
              <CommonDatePicker
                format="DD/MM/YYYY HH:mm"
                disabled={!isFieldEnable}
              />
            </SecureFormItem>
          </StyledGridCol>
        </StyledGridRow>
      </FieldSecurityProvider>
    </>
  );
};

export default JailIncidentInmateAdmitsGuilt;
